export const getCurrentFinancialYear = () => {
  var date = new Date();
  var currentFinancialYear = date.getFullYear();
  if (date.getMonth() == 11) {
    return currentFinancialYear + 1;
  }
  return currentFinancialYear;
};

export const generateSummerNoteMessage = (summernoteContent, fullName) => {
  var div = `<div id='${new Date().getTime()}' data-name='${fullName}' > {{content}} </div>`;
  var content =
    "<i>" +
    fullName +
    "</i> " +
    " <i>" +
    new Date().toLocaleString() +
    "</i>" +
    `<i class="icon fas fa-edit ml-2"  style="color:black; display:none;" ></i>` +
    "<br>" +
    "<div name='content' >" +
    summernoteContent +
    "</div> <br/>";

  div = div.replace("{{content}}", content);

  return div;
};

export const generateNotificationMessage = (fullName, reportName) => {
  return (
    fullName +
    " has added a new message to " +
    reportName +
    " report in iLead Application"
  );
};

///convert new Date() to yyyy-mm-dd
export const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};
